export default {
  data () {
    return {
      pageSizeList: [10, 20, 30, 40]
    }
  },
  methods: {
    getStyle (el = '#main-content', h = 35) {
      let style = window.getComputedStyle(document.querySelector(el))
      return {
        top: (parseInt(style.top.slice(0, -2)) + h) + 'px',
        bottom: style.bottom,
        left: style.left,
        right: style.right
      }
    },
    getPageSizeList () {
      return [10, 20, 30, 40]
    }
  },
  mounted () {
  }
}